import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { BrowserRouter, Route, Routes, useSearchParams } from 'react-router-dom';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import BreadcrumbsNavigator, { BreadcrumbsNavigatorProps } from '@/components/shared/Breadcrumbs/BreadcrumbsNavigator';
import QuestionGradingHooks from './QuestionGradingHooks';
import HeaderWithFilters from './HeaderWithFilters';
import QuestionGradingSkeleton from './QuestionGradingSkeleton';
import QuestionResultsBody from './QuestionResultsBody';

interface QuestionGradingProps {
  breadcrumbsData: BreadcrumbsNavigatorProps
  programId: number;
  userId: number;
  userType: string;
}

const QuestionGrading = ({ breadcrumbsData, programId, userId, userType } : QuestionGradingProps) => {
  QuestionGradingHooks({ programId, userId, userType });
  const { isLoading, assignment } = useGradingStore();
  const [searchParams] = useSearchParams();

  const renderBreadcrumbsNav = () => (
    <BreadcrumbsNavigator
      page="grades"
      searchParams={searchParams}
      {...breadcrumbsData}
    />
  );

  if (isLoading) {
    return (
      <>
        {renderBreadcrumbsNav()}
        <QuestionGradingSkeleton />
      </>
    );
  }

  return (
    <>
      {renderBreadcrumbsNav()}
      <div className="tw-py-4">
        <h1>{assignment.assignment_details.type} Results by Question</h1>
      </div>
      <HeaderWithFilters />
      <QuestionResultsBody />
    </>
  );
};

const QuestionGradingWrapper = ({ breadcrumbsData, programId, userId, userType } : QuestionGradingProps) => (
  <ReactQueryProvider>
    <BrowserRouter basename="/teacher/assignments">
      <Routes>
        <Route
          element={(
            <QuestionGrading
              breadcrumbsData={breadcrumbsData}
              programId={programId}
              userId={userId}
              userType={userType}
            />
          )}
          path=":assignmentId/questions/:questionId"
        />
      </Routes>
    </BrowserRouter>
  </ReactQueryProvider>
);

export default QuestionGradingWrapper;
